import getHours from "date-fns/getHours";
import isSameDay from "date-fns/isSameDay";
import format from "date-fns/format";
import isAfter from "date-fns/isAfter";
import { AvailabilityValue } from "./index";
import { Locale as DateFnsLocale } from "date-fns";

export enum DayPeriodNames {
  night = "night",
  morning = "morning",
  afternoon = "afternoon",
  evening = "evening",
}
type DayPeriod = { key: DayPeriodNames; period: [number, number] };
export const DAY_PERIODS: DayPeriod[] = [
  {
    key: DayPeriodNames.night,
    period: [0, 6],
  },
  {
    key: DayPeriodNames.morning,
    period: [6, 12],
  },
  {
    key: DayPeriodNames.afternoon,
    period: [12, 18],
  },
  {
    key: DayPeriodNames.evening,
    period: [18, 24],
  },
];

export type DataSorted<T> = ({
  date: Date;
  dateDayStr: string;
  dateMonthStr: string;
} & {
  [k in DayPeriodNames]: T[];
})[];

export const detectDayPeriod = (date: Date): DayPeriodNames => {
  const foundPeriod = DAY_PERIODS.find(({ period: [start, end] }) => {
    const hours = getHours(date);
    return hours >= start && hours < end;
  });
  return foundPeriod ? foundPeriod.key : DayPeriodNames.night;
};

export const sortDataByDateByDay = (
  data: AvailabilityValue,
  locale: DateFnsLocale
): DataSorted<AvailabilityValue[0]> => {
  const res: DataSorted<AvailabilityValue[0]> = [];

  data.forEach((timeSlot) => {
    const existingDateArr = res.find(({ date }) => {
      return isSameDay(date, timeSlot.date);
    });
    if (existingDateArr) {
      // add time slot to existing day period group
      const periodGroup = existingDateArr[detectDayPeriod(timeSlot.date)];

      // created to sort timeSlots by ascend
      const slotPrevTimeIdx = periodGroup.findIndex(({ date }) =>
        isAfter(date, timeSlot.date)
      );

      if (~slotPrevTimeIdx) {
        periodGroup.splice(slotPrevTimeIdx, 0, timeSlot);
      } else {
        periodGroup.push(timeSlot);
      }

      return;
    }
    res.push({
      date: timeSlot.date,
      dateDayStr: format(timeSlot.date, "d", { locale }),
      dateMonthStr: format(timeSlot.date, "MMM", { locale }),
      [DayPeriodNames.night]: [],
      [DayPeriodNames.morning]: [],
      [DayPeriodNames.afternoon]: [],
      [DayPeriodNames.evening]: [],
      [detectDayPeriod(timeSlot.date)]: [timeSlot], // yes, it overrides one of previous fields
    });
  });

  return res;
};
